module.exports = __webpack_public_path__ + "img/EDS_120X35.2c13ef36.png";